import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5ii3peotq1: FaireBrandEntity = {
  token: "b_5ii3peotq1",
  type: "brand",
  name: "Macmillan Publishers",
  avatarUrl:
    "https://cdn.faire.com/fastly/0f3cacfbc1eb55cc74aee2cef8611e6078106b0946438957d875798952932ab5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e9e57d0c515915329f19c9e3589122f7a6727b793ef3a8078aac118a63f197e7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0f3cacfbc1eb55cc74aee2cef8611e6078106b0946438957d875798952932ab5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e9e57d0c515915329f19c9e3589122f7a6727b793ef3a8078aac118a63f197e7.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 216,
  isInsider: true,
  description:
    "Macmillan Publishers is a leading publishing company and home to some of the world’s most cherished authors and creators.\n\nOur imprints publish a wide range of genres and formats for every kind of reader — from adult fiction and nonfiction to many inspired children’s books. Our list features bestselling, award-winning literary talent, including the Nobel Prize, the Man Booker Prize, the Pulitzer Prize, the National Book Award, the Newbery Medal, and the Caldecott Medal. We deeply believe in the power of books to connect people, amplify diverse voices, create meaningful change, and make a lasting impact in the world.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:32.440Z",
    importedBy: "entity-db-cli",
  },
};
